import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bscheck-box',
	templateUrl:'./BSCheckBoxPluginCompPage.html',
	styles: [],
	styleUrls:['./BSCheckBoxPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSCheckBoxPluginCompPage
{
	mdContent_797 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.checkbox.BSCheckBox;
\`\`\``;
	mdContent_798 = `\`\`\`java
BSCheckBox()
\`\`\``;
	mdContent_799 = `\`\`\`java
BSCheckBox&lt;?&gt; cb = new BSCheckBox&lt;&gt;();
cb.setLabel("Accept Terms");
cb.setInline(true);
\`\`\``;
}
